import FormWizard2Container from "../../../../components/formsAndTable/forms/formLayout/formWizard2";

const FormWizard2 = () => {
  return <FormWizard2Container />;
};

export default FormWizard2;
